import React from 'react'
import { Typography, Box, Link } from '@mui/material'
import Tooltip from 'components/Common/ToolTip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import equiFaxLogo from '../../../assets/equifaxLogo.svg'

const PoweredByEquifax = () => {
  return (
    <Box display="flex" color="#66668F" textAlign="left" margin='20px 0 15px 18px'>
      <Box display="flex" alignItems="center" marginLeft="-18px">
        <Typography variant="caption">
          Markaaz curates, verifies, and updates data daily from global premium and public data services.&nbsp;
          <Tooltip
            placement="top-center"
            content={
              <Typography variant="body2" color="white">
                Markaaz Directory data is curated from global premium and public sources, including Equifax, public
                records, and user contributory processes.
                <br /><br />
                Our proprietary technology verifies and updates this data daily from our global network.
                <br /><br />
                <Link
                  href="https://support.markaaz.com/knowledge/data-methodology"
                  rel="noreferrer"
                  target="_blank"
                  underline="hover"
                  sx={{
                    display: 'inline',
                    marginLeft: '4px',
                    textDecorationColor: 'white !important'
                  }}
                >
                  <Typography component="span" variant="body2B" color="white">
                    Learn more
                  </Typography>
                </Link>{' '}
                about our data methodology.
              </Typography>
            }
          >
            <InfoOutlinedIcon fontSize="large" className="k-cursor-pointer" />
          </Tooltip>
          <br />
          Featured Directory partner: &nbsp;
          <img alt="EQUIFAX Logo" className="ml-1" src={equiFaxLogo} />
        </Typography>
      </Box>
    </Box>
  )
}

export default PoweredByEquifax
